// extracted by mini-css-extract-plugin
module.exports = {"ButtonPink":"style_ButtonPink__xe4SA","ButtonTransparent":"style_ButtonTransparent__v6WzR"};